
/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

import { APIClient } from "api/api_helper";
import { DISPENSING_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();


export const DispensingLabelApiService = {
    // SELECT ALL DISPENSING LABEL
    selectAll: (payload_data: any) => {
        const payload = {
            studyid: payload_data.studyid,
            subjectno: payload_data.subjectno,
            searchtext: payload_data.searchText || null,
            ipcategory:payload_data.ipcategory,
        };
        return api.create(sessionStorage.getItem("baseUrl") + "PharmacyDispensingSubjectDetails/SelectAll", payload);
    },
    // UPDATE DISPENSING LABEL PRINT
    updateLabel: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            printby: user?.userid,
            dispensingprintdetail: payload_data.dispensingprintdetail || [],
        };
        return api.create(sessionStorage.getItem("baseUrl") + "DispensingLabel/Update", payload);
    },
    // ADD after insertHistory:
    insertReprintHistory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            subjectno: payload_data.subjectno || null,
            printby: user?.userid,
            verifiedby: null,
            reasonforreprint: payload_data.reasonforreprint
                ? parseInt(payload_data.reasonforreprint, 10)
                : null,
            additionalcomments: payload_data.additionalcomments || null,
            printcount: payload_data.printcount || 1,
            jsondata: payload_data.jsondata || [],
        };
        return api.create(
            sessionStorage.getItem("baseUrl") + "DispenseLabelHistory/Insert",
            payload
        );
    },
};